module.exports = __webpack_public_path__ + "img/logo.088379cc.png";